import { useLocation } from 'react-router-dom';

import { parseUrlParams } from '@/services/tools/handleUrlParams';
import { QueryParamsProps } from '../TargetCampaignsProps';

export const useQueryParams = (): QueryParamsProps => {
    const location = useLocation();
    const query = parseUrlParams(location.search);
    const search = (query.search as string) ?? '';
    const perPage = +query.perPage || 10;
    const page = +query.page || 1;

    return { search, perPage, page };
};
